import { type HTMLAttributes, useRef } from 'react';

import * as Styled from './FormSection.styles';

export interface FormSectionProps extends HTMLAttributes<HTMLDivElement> {
  numberOfColumns: Styled.ContainerProps['$numberOfColumns'];
}

const FormSection = ({ children, numberOfColumns, ...props }: FormSectionProps) => {
  const formSectionRef = useRef<HTMLDivElement>(null);

  return (
    <Styled.Container ref={formSectionRef} $numberOfColumns={numberOfColumns} {...props}>
      {children}
    </Styled.Container>
  );
};

export default FormSection;
